import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=724b3590&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724b3590')) {
      api.createRecord('724b3590', component.options)
    } else {
      api.reload('724b3590', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=724b3590&", function () {
      api.rerender('724b3590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/documents/Index.vue"
export default component.exports